import { RootState } from "@/app/stores"
import { foundationAccrual } from "@/shared/api/social-programs"
import { ErrorType, IBonusAccrualResponse } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

interface IFoundationAccrualRequest {
    program_id: string
    bonus_id: string
    amount_nano: number
    comment: string
}

export const fetchFoundationAccrual = createAsyncThunk<
    IBonusAccrualResponse,
    IFoundationAccrualRequest,
    { state: RootState }
>('foundationAccrual/fetchFoundationAccrual', async(data, thunkAPI) => {
    try {
        const response = await foundationAccrual(data.program_id, {
            bonus_id: data.bonus_id,
            amount_nano: data.amount_nano,
            comment: data.comment,
        })
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
